import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=5fabe838&lang=pug&"
import script from "./ReminderModal.vue?vue&type=script&lang=ts&"
export * from "./ReminderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports